@if (isLoading) {
<div class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
} @else if (orderItems) {
<div class="user-review-container">
    <div class="top-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">Write a Review</p>
                <p class="subtitle">
                    <span class="status">Tell others what you think</span>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="bottom-section">
    @for (item of orderItems;let i = $index; track i) {
    <div class="item-container">
        <div class="image-container" [class]="'product-image-gradient' + ((i % 3) + 1)">
            <img class="image" [src]="item.product?.images?.imagesUrl?.[0]" />
        </div>

        <div class="right-section">
            <p class="name font-poppins">{{ item.product?.name }}</p>
            <div class="star-container">
                <mat-icon *ngFor="let _ of [].constructor(5)" svgIcon="fullstar" class="star-icon"></mat-icon>
            </div>

            <button
                class="review-btn btn-white"
                mat-flat-button
                [disabled]="isReviewDisabled(item.product)"
                (click)="navigateRating(item.id!)"
            >
                {{ "userReviewPage.button.review" | translate }}
            </button>
        </div>
    </div>
    }
</div>

} @else {
<div class="no-order-container">
    <app-no-order-item></app-no-order-item>
</div>
}
